import { render, staticRenderFns } from "./JobRenewContractProfileCard.vue?vue&type=template&id=f6c99824&"
import script from "./JobRenewContractProfileCard.vue?vue&type=script&lang=js&"
export * from "./JobRenewContractProfileCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports